import * as Yup from "yup";

export const initialValues = {mobile: ""};

export const validationSchema = Yup.object({
    mobile: Yup.string()
        .matches(/^09\d{9}$/, "شماره موبایل باید 11 رقم و با 09 شروع شود")
        .required("شماره موبایل را وارد کنید")
});
